/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, Button, Stepper, Step, StepLabel, StepContent, FormControl, InputLabel, Select, FormHelperText, MenuItem, CircularProgress } from '@material-ui/core'

import Actions from '../../../fluid/Actions/ActionFactory'

import FieldMap from './FieldMap'

const clone = require('rfdc')()


const blue_theme = createMuiTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
          main: "#dc004e",
        },
    },
})


const styles = theme => ({

})

function getSteps() {
    return ['Select Information Units', 'Map Information Unit Fields'];
}

class SetIUnFieldMaps extends Component {
    state = {
        activeStep : 0,
        steps : getSteps(),
        ic_name : null,
        ic_name_received : false,
        ic_ius : null,
        ic_ius_received : false,
        iu_names : null,
        iu_names_error : false,
        submitting_iu_names : false,
        submitting_iu_names_error : false,
        iu_fields_map : null,
        iu_fields_map_error : false,
        iu_fields_map_received : false,
        receiving_iu_fields_map : false,
        submitting_iu_maps : false,
        submit_iu_fields_map_error : false
    }

    heading = React.createRef()
    footer = React.createRef()

    componentWillMount () {
        // Actions('http_request', {
        //     url : '/sainapse/workflow/' + this.props.wf_name,
        //     method : 'get',
        //     data : {}
        // }).then(res => {
        //     this.setState({...this.state, ic_name : res.data.result.ic_name, ic_name_received : true})
        // }).catch(err => {
        //     this.setState({...this.state, ic_name : null, ic_name_received : true})
        // })
    }

    componentDidMount () {
        const headingHeight = this.heading.current.clientHeight
        const footerHeight = this.footer.current.clientHeight
        const contentHeight = this.props.maxHeight - headingHeight - footerHeight

        this.setState({...this.state, content_height : contentHeight, heading_height : headingHeight}, () => {
            Actions('http_request', {
                url : '/sainapse/workflow/' + this.props.wf_name + '/information_unit_names_schema',
                method : 'get',
                data : {}
            }).then(res => {
                console.log('WF - IUs Required: ', res.data.result)
                this.setState({...this.state, iu_names : res.data.result, iu_names_error : false}, () => {
                    if(res.data.result.length > 0 ){
                        Actions('http_request', {
                            url : '/sainapse/information_channel/' + this.props.ic_name,
                            method : 'get',
                            data : {}
                        }).then(res => {
                            let iu_names = []
                            res.data.result.information_units.map(iu => {
                                iu_names.push(iu)
                            })
    
                            this.setState({...this.state, ic_ius : iu_names, ic_ius_received : true}, () => console.log("WF - State :", this.state))
                        })
                    } else {
                        this.setState({...this.state, ic_ius : [], ic_ius_received : true}, () => console.log("WF - State :", this.state))
                    }
                   
                })
            }).catch(err => {
                this.setState({...this.state, iu_names : null, iu_names_error : true})
            })
        })
    }

    getStepContent = (step) => {
        switch (step) {
            case 0:
                return this.renderIUSelection()
            
            case 1:
                return this.renderIUFieldMapsList()

            default:
                return null
        }
    }

    renderIUSelection = () => {
        if (this.state.iu_names_error === false && this.state.ic_ius_received === true) {
            return (
                <Fragment>
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', flexWrap : 'wrap', padding : '10px'}}>
                        {this.renderIUSelects()}
                    </div>
                    {this.state.ic_ius_received && this.state.iu_names.length > 0 ? 
                    (
                        <Button
                            style = {{
                                margin: '10px',
                            }}
                            variant = 'contained'
                            size = 'small'
                            color = 'primary'
                            onClick = {this.submitIUNames}
                            startIcon = {this.state.submitting_iu_names ? <CircularProgress style = {{color : '#FFFFFF'}} size = {20}/> : null}
                        >Submit</Button>
                    ) :
                    (
                        <Button
                            style = {{
                                margin: '10px',
                            }}
                            variant = 'contained'
                            size = 'small'
                            color = 'primary'
                            onClick = {this.props.handleNext}
                        >Skip</Button>
                    )}
                    {this.state.submitting_iu_names_error ? <Typography style = {{display : 'block', marginTop :'5px'}} variant = 'caption' color = 'secondary'>Error submitting IU Names</Typography> : null}
                </Fragment>
            )
        } else {
            if (this.state.iu_names_error === true) {
                return (
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography variant = 'caption' color = 'secondary'>Error Retreiving Information Unit Names</Typography>
                    </div>
                )
            }

            if (this.props.ic_name === null) {
                return (
                    <div style = {{width : '100%', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography variant = 'caption' color = 'secondary'>Error Retreiving Information Channel Name</Typography>
                    </div>
                )
            }
        }
    }

    setIUName = (name, iu_name) => {
        let iu_index = this.state.iu_names.findIndex(iu => iu.name === name)
        let new_state = clone(this.state)
        let iu_names = new_state.iu_names
        iu_names[iu_index].value.text = iu_name

        this.setState({...new_state})
    }

    renderIUList = (type) => {
        let iu_list
        if (type !== 'UNKNOWN') {
            iu_list = this.state.ic_ius.filter(iu => iu.type === type)
        } else {
            iu_list = this.state.ic_ius
        }

        let iu_menu_list = iu_list.map(iu => {
            return (
                <MenuItem value = {iu.name}>{iu.name}</MenuItem>
            )
        })

        return iu_menu_list
    }

    renderIUSelects = () => {
        if (this.state.iu_names.length > 0) {
            let iu_list = this.state.iu_names.map(iu => {
                return (
                    <FormControl style = {{marginLeft : '10px', marginBottom : '10px', width : '30%'}}>
                        <InputLabel id="demo-simple-select-label">{iu.name}</InputLabel>
                        <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={iu.value.text}
                        onChange={(event) => this.setIUName(iu.name, event.target.value)}
                        >
                            {this.renderIUList(iu.component_params.find(obj => obj.name === 'type').value.text)}
                        </Select>
                        <FormHelperText>{iu.component_params.find(obj => obj.name === 'helper_text').value.text}</FormHelperText>
                    </FormControl>
                )
            })
    
            return iu_list
        } else {
            return (
                <div style = {{
                    width : '100%',
                    height: this.content_height,
                    display : 'flex',
                    flexDirection : 'row',
                    alignItems : 'center',
                    justifyContent: 'center'
                }}> 
                    <Typography variant = 'caption' color = 'textSecondary'>This WF does not need any IU Mapping.</Typography>
                </div>
            )
        }
        
    }

    submitIUNames = () => {
        this.setState({...this.state, submitting_iu_names : true}, () => {
            Actions('http_request', {
                url : '/sainapse/workflow/' + this.props.wf_name + '/information_unit_names',
                method : 'post',
                data : this.state.iu_names
            }).then(res => {
                this.setState({...this.state, submitting_iu_names : false, activeStep : 1, receiving_iu_fields_map : true}, () => this.props.handleNext())
            }).catch(err => {
                this.setState({...this.state, submitting_iu_names : false, submitting_iu_names_error : true})
            })
        })
    }

    renderIUFieldMapsList = () => {
        if (this.state.iu_fields_map !== null) {
            return (
                <div style = {{width : '100%', height : this.props.maxHeight * 0.6, display : 'flex', flexDirection : 'row', overflow: 'scroll', padding : '8px'}}>
                    {this.renderIUFieldMaps()}
                </div>
            )
        } else {
            if (this.state.iu_fields_map_received === true && this.state.iu_fields_map_error === true) {
                return (
                    <div style = {{width : '100%', height : this.props.maxHeight * 0.6, display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography variant = 'caption' color = 'secondary'>Error Retreiving Field Maps</Typography>
                    </div>
                )
            }
        }
    }

    renderIUFieldMaps = () => {
        let field_maps = this.state.iu_fields_map.map(field_map => {
            let source_iu = field_map.sourceIU
            let destination_iu = field_map.destinationIU

            return (
                <FieldMap 
                    field_map = {field_map} 
                    ic_name = {this.props.ic_name} 
                    source_iu_type = {this.getIUType(source_iu)} 
                    destination_iu_type = {this.getIUType(destination_iu)}
                    set_field_map = {(id, field_map) => this.setFieldMap(id, field_map)}
                />
            )
        })

        return field_maps
    }

    getIUType = (iu_name) => {
        let type = this.state.ic_ius.find(iu => iu.name === iu_name).type
        console.log("WF - IU Name : " + iu_name + " - IU Type : " + type)
        return type
    }

    setFieldMap = (id, field_map) => {
        console.log("WF - FM ID :", id)
        console.log("WF - FM : ", field_map)
        let new_state = clone(this.state)
        let field_maps = new_state.iu_fields_map
        let index = field_maps.findIndex(field_map => field_map.id === id)
        field_maps[index].fieldMap = field_map

        this.setState({...new_state}, () => console.log("WF - Set Field Map State :", this.state))
    }

    setIUMaps = () => {

        this.setState({...this.state, submitting_iu_maps : true}, () => {
            let { ic_ius, ic_ius_received } = this.state;

            if(ic_ius.length > 0) {
                Actions('http_request', {
                    url : '/sainapse/workflow/' + this.props.wf_name + '/information_unit_field_mapping',
                    method: 'post',
                    data : this.state.iu_fields_map
                }).then(res => {
                    this.setState({...this.state, submitting_iu_maps : false}, () => this.props.handleNext())
                }).catch(err => {
                    this.setState({...this.state, submitting_iu_maps : false, submit_iu_fields_map_error : true})
                })
            } else {
                this.props.handleNext()
            }
            
        })
    }

    renderContent = () => {
        let { ic_ius, ic_ius_received } = this.state;
        if( ic_ius_received ){
            if( ic_ius.length > 0 ){
                return (
                    <Stepper activeStep={this.state.activeStep} orientation="vertical">
                        {this.state.steps.map((label, i) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                                <StepContent>{this.getStepContent(i)}</StepContent>
                            </Step>
                        ))}
                    </Stepper>
                )
            } else {
                return (
                    <div style = {{width : '100%', height : '100%', display: 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                        <Typography variant = 'body2'>This Workflow does not require this step</Typography>
                    </div>
                )
            }
        }
        
        
       
    }


    renderSubmit = () => {
        return (
            <Fragment>
                {
                    this.state.ic_ius_received && this.state.iu_names.length > 0 ? (
                        <Button
                            variant = 'contained'
                            color = 'primary'
                            size = 'small'
                            startIcon = {this.state.submitting_iu_maps ? <CircularProgress style = {{color : '#FFFFFF'}} size = {20}/> : null}
                            onClick = {this.setIUMaps}
                            disabled={ this.state.iu_fields_map === null }
                        >
                            Submit
                        </Button>
                    ) : (
                        <Button
                            variant = 'contained'
                            color = 'primary'
                            size = 'small'
                            startIcon = {this.state.submitting_iu_maps ? <CircularProgress style = {{color : '#FFFFFF'}} size = {20}/> : null}
                            onClick = {this.setIUMaps}
                        >
                            Skip
                        </Button>
                    )
                }
                
            </Fragment>
        )
    }
    

    render() {
        const { classes } = this.props
        return (
            <Paper elevation = {0} square style = {{width : '100%', height : this.props.maxHeight + 'px', overflow : 'scroll'}}>
                <div ref = {this.heading} 
                    style = {{
                        display : 'flex', 
                        flexDirection : 'row', 
                        alignItems : 'center',
                        alignContent : 'flex-end',
                        backgroundColor : '#F0F0F0',
                        borderBottom : '1px solid rgba(0,0,0,0.12)',
                        padding : '8px'
                    }}>
                    <Typography variant='h6' style ={{flexGrow : 1}}>Select Information Units</Typography>
                    <Typography style = {{marginleft: '10px', color : '#F50157'}} variant = 'caption'>{this.state.error_message}</Typography>
                </div>
                <div 
                    style = {{
                        width : '100%',
                        height: this.state.content_height,
                        maxHeight : this.state.content_height,
                        overflow: 'scroll'
                    }}
                >
                    <ThemeProvider theme = {blue_theme}>
                        {
                            this.renderIUSelection()
                        }
                        
                    </ThemeProvider>
                </div>
                <div ref = {this.footer} 
                    style = {{
                        display : 'flex', 
                        flexDirection : 'row-reverse',
                        backgroundColor : '#F0F0F0',
                        padding : '8px',
                        borderTop : '1px solid rgba(0,0,0,0.12)',
                    }}>
                    {/* <ThemeProvider theme = {blue_theme}>
                       {
                           this.renderSubmit()
                       }
                    </ThemeProvider> */}
                </div>
            </Paper>
        );
    }
}

export default withStyles(styles)(SetIUnFieldMaps);